import script from "./Page.vue?vue&type=script&setup=true&lang=ts"
export * from "./Page.vue?vue&type=script&setup=true&lang=ts"

import "./Page.vue?vue&type=style&index=0&id=f40265ee&lang=scss&scoped=true"

import exportComponent from "../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f40265ee"]])

export default __exports__